import React from 'react';
import { WeekYear } from '../date.utils';
import {
  PracticeGroupManipulation,
  UHAKlasserMedEmne,
} from '../components/calendar';

export interface CalendarUhaData {
  handleWeekHover: (w: WeekYear | null) => void;
  onCellClick: (aktivitetId: string) => void;
  filteredMode: boolean;
  weekNumbers: WeekYear[];
  isWeekly: boolean;
  earliestVisibleIsoDate: string;
  manipulateGroup: (
    klasserMedEmne: UHAKlasserMedEmne,
    type: PracticeGroupManipulation,
  ) => void;
  startYear: number;
}

export const CalendarUhaContext = React.createContext<CalendarUhaData>({
  handleWeekHover: () => {},
  onCellClick: () => {},
  filteredMode: false,
  weekNumbers: [],
  earliestVisibleIsoDate: '',
  isWeekly: true,
  startYear: 0,
  manipulateGroup: () => {},
});
